import { Layout, Tag, type TagProps } from '@loadsmart/miranda-react'

import { type ShipmentTag } from '../domain/ShipmentTag'
import { getTagVariantFromHex } from '../presenter/shipmentTagPresenter'

export type ShipmentTagsProps = {
  tags?: Array<ShipmentTag>
  size?: TagProps['size']
}

export function ShipmentTags({ tags, size = 'default' }: ShipmentTagsProps) {
  if (!tags?.length) return null

  return (
    <Layout.Group gap="spacing-1" align="center" data-testid="shipment-tags">
      {tags.map(tag => {
        const variant = getTagVariantFromHex(tag.color)
        return (
          <Tag key={tag.uuid} size={size} title={tag.name} variant={variant}>
            {tag.name}
          </Tag>
        )
      })}
    </Layout.Group>
  )
}
